export const WINDOW_FLUTTER_PROP_NAME = 'flutter_inappwebview'
